import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-appbg text-white">
      <Header />
      <div className="px-4 md:px-8 lg:px-12 py-12 max-w-2xl" data-testid="payment-cancel-page">
        <div className="border border-neutral-700 p-8 bg-appcard">
          <XCircle className="text-blaze" size={48} />
          <div className="heading text-4xl mt-4">CHECKOUT CANCELED.</div>
          <p className="text-neutral-300 mt-3">No charge was made. You can restart checkout any time.</p>
          <div className="mt-6 flex gap-3">
            <button onClick={() => nav(-1)} className="bg-blaze text-white heading text-base px-5 py-3 hover:glow-blaze" data-testid="cancel-retry-btn">GO BACK</button>
            <Link to="/" className="border border-neutral-700 text-neutral-200 heading text-base px-5 py-3 hover:border-white" data-testid="cancel-home-btn">HOME</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
